const _constants = {
  candlesCount: 20,
  candlesHeight: window.innerHeight > 1100 ? 10 : 8,
  candleBlockSize: 35,
  candleDistance: 25,
  chartAnimationDurationMS: 700,
  figureAnimationDurationMS: 1000,
  pauseBetweenChartAnimationsMS: 800,
  groundHeight: 66,
};

_constants.contentWidth =
  (_constants.candlesCount - 1) *
  (_constants.candleBlockSize + _constants.candleDistance);

export default _constants;
